// extracted by mini-css-extract-plugin
export default {"pageWrap":"Ed-z","fullWidth":"Fd-z","heading":"Gd-z","fullBleed":"Hd-z","hidden":"Id-z"};